/* BaseRefResolver.js */

'use strict';
const _ = require('lodash');
const EventEmitter = require('events').EventEmitter;

class BaseRefResolver extends EventEmitter {
  constructor(nibApiService, userSession, instancesInControlFormat = false) {
    super();
    this._nibApiService = nibApiService;
    this._userSession = userSession;
    this._instancesInControlFormat = instancesInControlFormat;
  }
  //Doing this to work around the getExistingRefs API
  _sanitizeRef(ref) {
    return ref.replace(/^\//, '').replace(/\*+$/, '');
  }
  getAllPossibleRefInstances(refTypes) {
    let refInstances = {};
    let proms = [];
    Object.keys(refTypes).forEach((constructTypePathInfo) => {
      let ref = _.get(refTypes, constructTypePathInfo + '.labPath');
      if (ref) {
        proms.push(
          Promise.resolve()
            .then(() => {
              return this._nibApiService.getExistingRefs({
                ref: this._sanitizeRef(ref),
                orgId: _.get(this._userSession, 'activeOrganization.id'),
                instancesInControlFormat: this._instancesInControlFormat,
              });
            })
            .then((foundRefs) => {
              if (!_.isEmpty(foundRefs)) {
                refInstances[constructTypePathInfo] = [];
                foundRefs.forEach((foundRef) => {
                  if (_.isPlainObject(foundRef)) {
                    refInstances[constructTypePathInfo].push(foundRef);
                  } else {
                    let name = foundRef.replace(/\.json/, '');
                    refInstances[constructTypePathInfo].push({
                      id: name,
                      instanceName: name,
                      labPath: ref,
                    });
                  }
                });
              }
            })
        );
      }
    });
    return Promise.all(proms).then(() => {
      return refInstances;
    });
  }
}
module.exports = BaseRefResolver;
